// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#select-board-dialog-container > .dialogBlock {
    width: 640px;
    height: 500px;
}

div#select-board-dialog {
    margin: 5px;
    height: 100%;
}

div#select-board-dialog .selectBoardContainer {
    display: flex;
    gap: 10px;
    overflow: hidden;
    max-height: 100%;
    height: 100%;
}

.select-board-dialog .head {
    margin: 5px;
}

.dialogContent.select-board-dialog {
    height: 100%;
}

div.dialogContent.select-board-dialog > div.head .title {
    font-weight: 400;
    letter-spacing: 0.02em;
    font-size: 1.2em;
    color: var(--theia-editorWidget-foreground);
    margin-bottom: 10px;
}

div#select-board-dialog .selectBoardContainer .list .item.selected {
    background: var(--theia-secondaryButton-hoverBackground);
}

div#select-board-dialog .selectBoardContainer .list .item.selected i {
    color: var(--theia-arduino-branding-primary);
}

#select-board-dialog .selectBoardContainer .search,
#select-board-dialog .selectBoardContainer .search input,
#select-board-dialog .selectBoardContainer .list,
#select-board-dialog .selectBoardContainer .list {
    background: var(--theia-editor-background);
}

#select-board-dialog .selectBoardContainer .search input {
    border: none;
    width: 100%;
    height: auto;
    max-height: 37px;
    padding: 10px 5px 10px 10px;
    margin: 0;
    vertical-align: top;
    display: flex;
    color: var(--theia-input-foreground);
}

#select-board-dialog .selectBoardContainer .search input:focus {
    box-shadow: none;
}

#select-board-dialog .selectBoardContainer .container {
    flex: 1;
    overflow: hidden;
    max-height: 100%;
}

#select-board-dialog .selectBoardContainer .container .content {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    height: 100%;
}

#select-board-dialog .selectBoardContainer .left.container .content {
    margin: 0 5px 0 0;
}

#select-board-dialog .selectBoardContainer .right.container .content {
    margin: 0 0 0 5px;
}

#select-board-dialog .selectBoardContainer .container .content .title {
    color: var(--theia-editorWidget-foreground);
    padding: 0px 0px 10px 0px;
    text-transform: uppercase;
}

#select-board-dialog .selectBoardContainer .container .content .footer {
    padding: 10px 5px 10px 0px;
}

#select-board-dialog .selectBoardContainer .container .content .loading {
    font-size: var(--theia-ui-font-size1);
    color: var(--theia-editorWidget-foreground);
    padding: 10px 5px 10px 10px;
    text-transform: uppercase;
    /* The max, min-height comes from \`.list\` 200px + 47px top padding - 2 * 10px top padding */
    max-height: 227px;
    min-height: 227px;
}

#select-board-dialog .selectBoardContainer .list .item {
    padding: 10px 5px 10px 10px;
    display: flex;
    white-space: nowrap;
    overflow-x: hidden;
    flex: 1 0;
}

#select-board-dialog .selectBoardContainer .list .item .selected-icon {
    margin-left: auto;
}

#select-board-dialog .selectBoardContainer .list .item .details {
    font-size: var(--theia-ui-font-size1);
    opacity: var(--theia-mod-disabled-opacity);
    width: 155px; /* used heuristics for the calculation */
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
}

#select-board-dialog .selectBoardContainer .list .item.missing {
    opacity: var(--theia-mod-disabled-opacity);
}

#select-board-dialog .selectBoardContainer .list .item:hover {
    background: var(--theia-secondaryButton-hoverBackground);
}

#select-board-dialog .selectBoardContainer .list .label {
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
}

#select-board-dialog .selectBoardContainer .list {
    max-height: 200px;
    overflow-y: auto;
    flex: 1;
}

#select-board-dialog .selectBoardContainer .ports.list {
    margin: 47px 0px 0px 0px; /* 47 is 37 as input height for the \`Boards\`, plus 10 margin bottom. */
}

#select-board-dialog .selectBoardContainer .search {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    padding-right: 5px;
}

.arduino-boards-toolbar-item-container {
    align-items: center;
    background: var(--theia-arduino-toolbar-dropdown-background);
    border-radius: 1px;
    color: var(--theia-arduino-toolbar-dropdown-label);
    border: 1px solid var(--theia-arduino-toolbar-dropdown-border);
    display: flex;
    gap: 10px;
    height: var(--arduino-button-height);
    margin: 0 4px;
    overflow: hidden;
    padding: 0 10px;
    width: 210px;
}

.arduino-boards-toolbar-item--protocol,
.arduino-boards-dropdown-item--protocol {
    align-items: center;
    display: flex;
    font-size: 16px;
}

.arduino-boards-toolbar-item--protocol,
.arduino-boards-dropdown-item--protocol {
    color: var(--theia-arduino-toolbar-dropdown-label);
}

.arduino-boards-toolbar-item-container .arduino-boards-toolbar-item {
    display: flex;
    align-items: baseline;
    width: 100%;
}

.arduino-boards-toolbar-item--label {
    width: 100%;
}

.arduino-boards-toolbar-item--label-connected {
    font-family: "Open Sans Bold";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
}

.arduino-boards-toolbar-item-container .caret {
    width: 10px;
    margin-right: 5px;
}

.arduino-boards-dropdown-list {
    margin: -1px;
    z-index: 1;
    border: 1px solid var(--theia-arduino-toolbar-dropdown-border);
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
}

.arduino-boards-dropdown-list:focus {
    border: 1px solid var(--theia-arduino-toolbar-dropdown-borderActive);
}

.arduino-boards-dropdown-list--items-container {
    overflow: auto;
    max-height: 404px;
    background: var(--theia-arduino-toolbar-dropdown-background);
}

.arduino-boards-dropdown-list--items-container::-webkit-scrollbar {
    background: var(--theia-arduino-toolbar-dropdown-background);
}

.arduino-boards-dropdown-item {
    background: var(--theia-arduino-toolbar-dropdown-background);
    color: var(--theia-arduino-toolbar-dropdown-label);
    cursor: default;
    display: flex;
    font-size: var(--theia-ui-font-size1);
    justify-content: space-between;
    padding: 10px;
}

.arduino-boards-dropdown-item--board-header {
    display: flex;
    align-items: center;
}

.arduino-boards-dropdown-item--label {
    overflow: hidden;
    flex: 1;
}

/* Redefine default codicon size https://github.com/microsoft/vscode/commit/38cd0a377b7abef34fb07fe770fc633e68819ba6 */
.arduino-boards-dropdown-item .codicon[class*="codicon-"] {
    font-size: 14px;
}

.arduino-boards-dropdown-item .p-TabBar-toolbar {
    padding: 0px;
    margin: 0px;
    flex-direction: column;
}

.arduino-boards-dropdown-item .p-TabBar-toolbar .item {
    margin: 0px;
}

.arduino-boards-dropdown-item .p-TabBar-toolbar .item .action-label {
    padding: 0px;
}

.arduino-boards-dropdown-item--board-label {
    font-size: 14px;
}

.arduino-boards-dropdown-item .arduino-boards-dropdown-item--protocol {
    margin-right: 10px;
}

.arduino-boards-dropdown-item--port-label {
    font-size: 12px;
}

.arduino-boards-dropdown-item:hover {
    background: var(--theia-arduino-toolbar-dropdown-option-backgroundHover);
}

.arduino-boards-dropdown-item--selected,
.arduino-boards-dropdown-item--selected:hover {
    background: var(--theia-arduino-toolbar-dropdown-option-backgroundSelected);
    border: 1px solid
        var(--theia-arduino-toolbar-dropdown-option-backgroundSelected);
}

.arduino-boards-dropdown-item--selected
    .arduino-boards-dropdown-item--port-label {
    color: var(--theia-arduino-toolbar-dropdown-label);
}

.arduino-boards-dropdown-item--selected .fa {
    color: var(--theia-arduino-toolbar-dropdown-iconSelected);
}

.arduino-board-dropdown-footer {
    color: var(--theia-secondaryButton-foreground);
    border-top: 1px solid var(--theia-dropdown-border);
}

@media only screen and (max-height: 400px) {
    div.dialogContent.select-board-dialog > div.head {
        display: none;
    }

    #select-board-dialog .selectBoardContainer .container .content .title {
        display: none;
    }
}

#select-board-dialog .no-result {
    text-transform: uppercase;
    height: 100%;
    user-select: none;
    padding: 10px 5px;
    overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/boards-config-dialog.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;;;IAII,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,2BAA2B;IAC3B,yBAAyB;IACzB,2FAA2F;IAC3F,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,YAAY,EAAE,wCAAwC;IACtD,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,wBAAwB,EAAE,sEAAsE;AACpG;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,4DAA4D;IAC5D,kBAAkB;IAClB,kDAAkD;IAClD,8DAA8D;IAC9D,aAAa;IACb,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,8DAA8D;IAC9D,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,4DAA4D;AAChE;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,4DAA4D;IAC5D,kDAAkD;IAClD,eAAe;IACf,aAAa;IACb,qCAAqC;IACrC,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,OAAO;AACX;;AAEA,sHAAsH;AACtH;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;;IAEI,2EAA2E;IAC3E;uEACmE;AACvE;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,8CAA8C;IAC9C,kDAAkD;AACtD;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B","sourcesContent":["#select-board-dialog-container > .dialogBlock {\r\n    width: 640px;\r\n    height: 500px;\r\n}\r\n\r\ndiv#select-board-dialog {\r\n    margin: 5px;\r\n    height: 100%;\r\n}\r\n\r\ndiv#select-board-dialog .selectBoardContainer {\r\n    display: flex;\r\n    gap: 10px;\r\n    overflow: hidden;\r\n    max-height: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.select-board-dialog .head {\r\n    margin: 5px;\r\n}\r\n\r\n.dialogContent.select-board-dialog {\r\n    height: 100%;\r\n}\r\n\r\ndiv.dialogContent.select-board-dialog > div.head .title {\r\n    font-weight: 400;\r\n    letter-spacing: 0.02em;\r\n    font-size: 1.2em;\r\n    color: var(--theia-editorWidget-foreground);\r\n    margin-bottom: 10px;\r\n}\r\n\r\ndiv#select-board-dialog .selectBoardContainer .list .item.selected {\r\n    background: var(--theia-secondaryButton-hoverBackground);\r\n}\r\n\r\ndiv#select-board-dialog .selectBoardContainer .list .item.selected i {\r\n    color: var(--theia-arduino-branding-primary);\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .search,\r\n#select-board-dialog .selectBoardContainer .search input,\r\n#select-board-dialog .selectBoardContainer .list,\r\n#select-board-dialog .selectBoardContainer .list {\r\n    background: var(--theia-editor-background);\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .search input {\r\n    border: none;\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 37px;\r\n    padding: 10px 5px 10px 10px;\r\n    margin: 0;\r\n    vertical-align: top;\r\n    display: flex;\r\n    color: var(--theia-input-foreground);\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .search input:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .container {\r\n    flex: 1;\r\n    overflow: hidden;\r\n    max-height: 100%;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .container .content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: 100%;\r\n    height: 100%;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .left.container .content {\r\n    margin: 0 5px 0 0;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .right.container .content {\r\n    margin: 0 0 0 5px;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .container .content .title {\r\n    color: var(--theia-editorWidget-foreground);\r\n    padding: 0px 0px 10px 0px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .container .content .footer {\r\n    padding: 10px 5px 10px 0px;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .container .content .loading {\r\n    font-size: var(--theia-ui-font-size1);\r\n    color: var(--theia-editorWidget-foreground);\r\n    padding: 10px 5px 10px 10px;\r\n    text-transform: uppercase;\r\n    /* The max, min-height comes from `.list` 200px + 47px top padding - 2 * 10px top padding */\r\n    max-height: 227px;\r\n    min-height: 227px;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .list .item {\r\n    padding: 10px 5px 10px 10px;\r\n    display: flex;\r\n    white-space: nowrap;\r\n    overflow-x: hidden;\r\n    flex: 1 0;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .list .item .selected-icon {\r\n    margin-left: auto;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .list .item .details {\r\n    font-size: var(--theia-ui-font-size1);\r\n    opacity: var(--theia-mod-disabled-opacity);\r\n    width: 155px; /* used heuristics for the calculation */\r\n    white-space: pre;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .list .item.missing {\r\n    opacity: var(--theia-mod-disabled-opacity);\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .list .item:hover {\r\n    background: var(--theia-secondaryButton-hoverBackground);\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .list .label {\r\n    white-space: pre;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .list {\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    flex: 1;\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .ports.list {\r\n    margin: 47px 0px 0px 0px; /* 47 is 37 as input height for the `Boards`, plus 10 margin bottom. */\r\n}\r\n\r\n#select-board-dialog .selectBoardContainer .search {\r\n    margin-bottom: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-right: 5px;\r\n}\r\n\r\n.arduino-boards-toolbar-item-container {\r\n    align-items: center;\r\n    background: var(--theia-arduino-toolbar-dropdown-background);\r\n    border-radius: 1px;\r\n    color: var(--theia-arduino-toolbar-dropdown-label);\r\n    border: 1px solid var(--theia-arduino-toolbar-dropdown-border);\r\n    display: flex;\r\n    gap: 10px;\r\n    height: var(--arduino-button-height);\r\n    margin: 0 4px;\r\n    overflow: hidden;\r\n    padding: 0 10px;\r\n    width: 210px;\r\n}\r\n\r\n.arduino-boards-toolbar-item--protocol,\r\n.arduino-boards-dropdown-item--protocol {\r\n    align-items: center;\r\n    display: flex;\r\n    font-size: 16px;\r\n}\r\n\r\n.arduino-boards-toolbar-item--protocol,\r\n.arduino-boards-dropdown-item--protocol {\r\n    color: var(--theia-arduino-toolbar-dropdown-label);\r\n}\r\n\r\n.arduino-boards-toolbar-item-container .arduino-boards-toolbar-item {\r\n    display: flex;\r\n    align-items: baseline;\r\n    width: 100%;\r\n}\r\n\r\n.arduino-boards-toolbar-item--label {\r\n    width: 100%;\r\n}\r\n\r\n.arduino-boards-toolbar-item--label-connected {\r\n    font-family: \"Open Sans Bold\";\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n}\r\n\r\n.arduino-boards-toolbar-item-container .caret {\r\n    width: 10px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.arduino-boards-dropdown-list {\r\n    margin: -1px;\r\n    z-index: 1;\r\n    border: 1px solid var(--theia-arduino-toolbar-dropdown-border);\r\n    font-family: \"Open Sans\";\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n}\r\n\r\n.arduino-boards-dropdown-list:focus {\r\n    border: 1px solid var(--theia-arduino-toolbar-dropdown-borderActive);\r\n}\r\n\r\n.arduino-boards-dropdown-list--items-container {\r\n    overflow: auto;\r\n    max-height: 404px;\r\n    background: var(--theia-arduino-toolbar-dropdown-background);\r\n}\r\n\r\n.arduino-boards-dropdown-list--items-container::-webkit-scrollbar {\r\n    background: var(--theia-arduino-toolbar-dropdown-background);\r\n}\r\n\r\n.arduino-boards-dropdown-item {\r\n    background: var(--theia-arduino-toolbar-dropdown-background);\r\n    color: var(--theia-arduino-toolbar-dropdown-label);\r\n    cursor: default;\r\n    display: flex;\r\n    font-size: var(--theia-ui-font-size1);\r\n    justify-content: space-between;\r\n    padding: 10px;\r\n}\r\n\r\n.arduino-boards-dropdown-item--board-header {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.arduino-boards-dropdown-item--label {\r\n    overflow: hidden;\r\n    flex: 1;\r\n}\r\n\r\n/* Redefine default codicon size https://github.com/microsoft/vscode/commit/38cd0a377b7abef34fb07fe770fc633e68819ba6 */\r\n.arduino-boards-dropdown-item .codicon[class*=\"codicon-\"] {\r\n    font-size: 14px;\r\n}\r\n\r\n.arduino-boards-dropdown-item .p-TabBar-toolbar {\r\n    padding: 0px;\r\n    margin: 0px;\r\n    flex-direction: column;\r\n}\r\n\r\n.arduino-boards-dropdown-item .p-TabBar-toolbar .item {\r\n    margin: 0px;\r\n}\r\n\r\n.arduino-boards-dropdown-item .p-TabBar-toolbar .item .action-label {\r\n    padding: 0px;\r\n}\r\n\r\n.arduino-boards-dropdown-item--board-label {\r\n    font-size: 14px;\r\n}\r\n\r\n.arduino-boards-dropdown-item .arduino-boards-dropdown-item--protocol {\r\n    margin-right: 10px;\r\n}\r\n\r\n.arduino-boards-dropdown-item--port-label {\r\n    font-size: 12px;\r\n}\r\n\r\n.arduino-boards-dropdown-item:hover {\r\n    background: var(--theia-arduino-toolbar-dropdown-option-backgroundHover);\r\n}\r\n\r\n.arduino-boards-dropdown-item--selected,\r\n.arduino-boards-dropdown-item--selected:hover {\r\n    background: var(--theia-arduino-toolbar-dropdown-option-backgroundSelected);\r\n    border: 1px solid\r\n        var(--theia-arduino-toolbar-dropdown-option-backgroundSelected);\r\n}\r\n\r\n.arduino-boards-dropdown-item--selected\r\n    .arduino-boards-dropdown-item--port-label {\r\n    color: var(--theia-arduino-toolbar-dropdown-label);\r\n}\r\n\r\n.arduino-boards-dropdown-item--selected .fa {\r\n    color: var(--theia-arduino-toolbar-dropdown-iconSelected);\r\n}\r\n\r\n.arduino-board-dropdown-footer {\r\n    color: var(--theia-secondaryButton-foreground);\r\n    border-top: 1px solid var(--theia-dropdown-border);\r\n}\r\n\r\n@media only screen and (max-height: 400px) {\r\n    div.dialogContent.select-board-dialog > div.head {\r\n        display: none;\r\n    }\r\n\r\n    #select-board-dialog .selectBoardContainer .container .content .title {\r\n        display: none;\r\n    }\r\n}\r\n\r\n#select-board-dialog .no-result {\r\n    text-transform: uppercase;\r\n    height: 100%;\r\n    user-select: none;\r\n    padding: 10px 5px;\r\n    overflow-wrap: break-word;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
